<template>
  <ul class="comment-list">
    <li v-for="comment in comments" :key="comment.id">
      <comments-list-item
        :comment="comment"
        @removeComment="removeComment"
        :reply="reply"
      />
    </li>
  </ul>
</template>
<script>
import CommentsListItem from "./CommentsListItem";

export default {
  name: "CommentsList",
  components: {
    CommentsListItem
  },
  props: ["reply", "comments"],
  methods: {
    removeComment: function(comment) {
      this.comments.splice(this.comments.indexOf(comment), 1);
    }
  }
};
</script>
